module.exports = "/_next/static/images/FeelConfidentAboutInvestments-c50bf78930274d8c9b9fba482c6d4b2a.svg";